export default "__VITE_ASSET__BTTsVloI__"